module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqAgMAAAC4rSHIAAAAAXNSR0IB2cksfwAAAAxQTFRFAAAAAAAAAAAAAAAANek3lgAAAAR0Uk5TAMD/v+rGo7UAAABUSURBVHiczZGxDcAgDASvSuFRmYYR3OI0GTFvIBL0KXjJ0hX/xcmUB64bEISDhVjgoZjOd147pWrbclsxZowjOL16pldPen3sO6+d9BrbM71++NcLswdCoexKLJIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/lay-transform_copy@2x.png
// module id = 845
// module chunks = 0